import { Action } from '@ngrx/store';
import { Prestadores } from '../../models/prestadores.model';

export const SET_PRESCRIPTORS = '[prestradores] Set Prescriptors';
export const SET_PRESCRIPTORS_SEARCH_TERM =
    '[prestradores] Set Prescriptors Search Term';
export const UNSET_PRESCRIPTORS = '[prestradores] Unset Prescriptors';
export const SET_SINGLE_PRESCRIPTOR = '[prestradores] Set Single Prescriptor';

export class SetPrescriptors implements Action {
    readonly type = SET_PRESCRIPTORS;
    constructor(
        public prestadoresSeteado: {
            contenido: Prestadores[];
            paginado: {
                elementosTotales: number;
                paginaActual: number;
                paginasTotales: number;
            };
        }
    ) {}
}

export class UnsetPrescriptors implements Action {
    readonly type = UNSET_PRESCRIPTORS;
}

export class SetPrescriptorsSearchTerm implements Action {
    readonly type = SET_PRESCRIPTORS_SEARCH_TERM;
    constructor(
        public search: { searchTerm: string[]; searchCriteria: string[] }
    ) {}
}

export class SetSinglePrescriptor implements Action {
    readonly type = SET_SINGLE_PRESCRIPTOR;
    constructor(public singlePrescriptorSeteado: Prestadores) {}
}

export type PrestadoresActions =
    | SetPrescriptors
    | UnsetPrescriptors
    | SetSinglePrescriptor
    | SetPrescriptorsSearchTerm;
